export default "__VITE_PUBLIC_ASSET__c7c943e4__"